<template>
	<div>
		<div style="margin: 0 auto;position: relative;">
			<img style="width: 100%;height: 100%;" src="http://dgoss.91dageng.com.cn/png/f1ddEmfYqMjbuDXP3011_蒙版组 2@3x.png" />

			<div class="tab-tit" style="position: absolute;bottom: 0px;left: 50%;transform:translate(-50%,50%);z-index:999;">
				<el-row>
					<el-col :xs="24" :sm="12"><div @click="curId = 0" class="cur1" :class="{ cur: curId === 0 }" style="">公司简介</div></el-col>
					<el-col :xs="24" :sm="12"><div @click="curId = 1" class="cur1" :class="{ cur: curId === 1 }" style="">公司文化</div></el-col>
				</el-row>
			</div>
		</div>
		<!-- 盒子 -->
		<div class="border_parent" style="margin-top: 70px;">
			<el-row :gutter="10">
				<div v-show="curId === 0">
					<div class="border_parent">
						<el-row :gutter="10">
							<el-col :xs="24" :sm="12">
								<div class="border">
									<div class="border_title" style="color: #0C76FF;text-align: left;font-weight: normal;margin: 10px 0;">Dageng Technology</div>
									<div style="color: #0C76FF;text-align: left;">大庚信息科技(上海)有限公司</div>
									<div style="margin: 20px 0;">大庚信息科技(上海)有限公司 (简称“大庚科技”)是国内第三方健康服务平台及健康管理解决方案提供商，具备大健康领域信息服务与运营能力，为客户提供健康咨询等系列化健康服务。</div>
									<div>大庚科技自2017年成立以来，秉承高起点、高标准、高品质的服务理念，专注于健康服务领域，已通过ISO9001质量管理体系认证及获得相关资质证书，累计服务200多家企业客户，主要致力于国内主要保险、金融等企业，为客户提供安心便捷、实用的健康管理服务和一体化解决方案。</div>
								</div>
							</el-col>
							<el-col :xs="24" :sm="12" style="display: flex;">
								<div class="border"><img style="display: flex;width: 100%;" src="http://dgoss.91dageng.com.cn/png/ZNEMJj23y1Zzs7hp1331_蒙版组 3@3x.png" /></div>
								<div class="border"><img style="display: flex;width: 100%;" src="http://dgoss.91dageng.com.cn/png/MoffHtp8TYxz3Msb1323_蒙版组 4@3x.png" /></div>
							</el-col>
						</el-row>
					</div>
				</div>
				<div v-show="curId === 1">
					<div class="border_parent">
						<el-row :gutter="10">
							<el-col :xs="24" :sm="6">
								<div class="border" style="display: flex;justify-content: center;flex-direction: row;">
									<div style="min-width: 160px;">
										<div>
											<div style="color: #333;font-size: 26px; text-align: left;">愿景</div>
											<div style="width: 100%;border: 1px solid #707070; margin: 10px 0;"></div>
											<div style="color: #333; text-align: left;">愿景</div>
										</div>
										<div style="margin: 40px 0;">
											<div style="color: #333;font-size: 26px; text-align: left;">核心价值观</div>
											<div style="width: 100%;border: 1px solid #707070; margin: 10px 0;"></div>
											<div style="color: #333; text-align: left;">核心价值观</div>
										</div>
									</div>
								</div>
							</el-col>
							<el-col :xs="24" :sm="6">
								<div class="border" style="display: flex;justify-content: center;flex-direction: row;">
									<div style="min-width: 160px;">
										<div>
											<div style="color: #333;font-size: 26px; text-align: left;">使命</div>
											<div style="width: 100%;border: 1px solid #707070; margin: 10px 0;"></div>
											<div style="color: #333; text-align: left;">使命</div>
										</div>
										<div style="margin: 40px 0;">
											<div style="color: #333;font-size: 26px; text-align: left;">公司理念</div>
											<div style="width: 100%;border: 1px solid #707070; margin: 10px 0;"></div>
											<div style="color: #333; text-align: left;">公司理念</div>
										</div>
									</div>
								</div>
							</el-col>
							<el-col :xs="24" :sm="12" style="display: flex;">
								<div class="border"><img style="display: flex;width: 100%;" src="http://dgoss.91dageng.com.cn/png/DuNQoeJVGWqbdAFz3310_画板 1@3x.png" /></div>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-row>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			curId: 0,
			carousel_height: '550px'
		};
	},
	computed: {
		//计算高度
		computeHeight() {
			let screenHeight = document.body.clientWidth;
			if (screenHeight > 415) {
				return '550px';
			} else {
				return '250px';
			}
		},
		computeArrowImg() {
			let screenHeight = document.body.clientWidth;
			if (screenHeight > 450) {
				return require('../../../static/other/arrow.png');
			} else {
				return require('../../../static/other/arrow_down.png');
			}
		}
	}
};
</script>

<style>
.border_parent {
	width: 90%;
	margin: 50px auto;
}

.slider_img {
	height: 550px;
	width: 100%;
}

.solve {
	margin-top: 30px;
	margin-bottom: 10px;
}

.border {
	border-radius: 6px;
	/* border: 1px solid #EBEEF5; */
	height: auto;
	margin: 10px;
	/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
}

.border_one {
	margin-left: 0;
}

.border_img_parent {
	margin-top: 20px;
	display: flex;
	justify-content: center;
}

.product_mobile_content {
	height: 300px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.product_mobile_img {
	width: 50%;
}

.product_mobile_title {
	font-weight: bold;
	text-align: center;
}

.product_pc_one {
	text-align: center;
	min-height: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.font_size_30 {
	font-size: 1.875em;
}

.product_font_style {
	font-size: 1.125em;
}

.product_pc_img {
	width: 100%;
}

.product_pc_img_div {
	width: 50%;
	float: left;
	display: flex;
	align-items: center;
}

.product_pc {
	display: flex;
	width: 90%;
	margin: 20px auto;
	background: #f2f6fc;
	align-items: center;
}

.product_spec_title {
	margin-top: 30px;
	margin-bottom: 10px;
}

.product_spec_parent {
	display: flex;
	width: 90%;
	margin: 20px auto;
	align-items: center;
	height: auto;
}

.cooperation_parent {
	display: flex;
	justify-content: center;
	width: 90%;
	margin: 20px auto;
	align-items: center;
	height: auto;
}

.border_spec {
	border-radius: 6px;
	border: 1px solid #ebeef5;
	float: left;
	width: 25%;
	height: auto;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
	font-size: 1.25em;
	font-weight: normal;
	padding: 0 20px;
	margin: 10px;
	color: #fff;
}

.border_title {
	font-family: 'PingFang SC';
	margin-top: 10px;
	font-size: 1.125em;
	font-weight: bold;
	text-align: center;
}

.border_content_one {
	margin-top: 20px;
	/* font-size: 1.125em; */
	color: #999;
	text-align: center;
}

.border_content_two {
	margin-top: 5px;
	font-size: 1.125em;
	margin-bottom: 25px;
	text-align: center;
	color: #0775ff;
	display: flex;
	justify-content: center;
}

.img_border {
	margin-top: 15px;
	width: 80px;
	height: 80px;
}

.border_spec_inner_one {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 35px;
	height: 70px;
}

.border_spec_content_one {
	margin-top: 15px;
	font-size: 1.125em;
	float: left;
	text-align: center;
}

.border_spec_inner_last {
	margin-top: 15px;
	font-size: 1.125em;
	float: left;
	margin-bottom: 25px;
	text-align: center;
}

.cooperation {
	margin-top: 30px;
	width: 100%;
}

.about_me {
	display: flex;
	margin-top: 30px;
	justify-content: center;
	width: 100%;
}

.product_mobile {
	width: 90%;
	align-items: center;
	margin: 20px auto;
	background: #f2f6fc;
}

.product_mobile_img_div {
	width: 50%;
	height: auto;
}

.product_mobile_content_one {
	margin-top: 20px;
	text-align: center;
}

.product_mobile_content_two {
	margin-top: 10px;
	text-align: center;
}
.tab-tit {
	display: flex;
	justify-content: center;
}
/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
	.slider_img {
		height: 250px;
		width: 100%;
	}

	.border_parent {
		display: flex;
		width: 90%;
		margin: auto;
		height: auto;
		flex-direction: column;
	}

	.border {
		border-radius: 6px;
		/* border: 1px solid #EBEEF5; */
		float: left;
		width: 100%;
		height: auto;
		margin: 10px 0 auto;
		/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
		/*background: aquamarine;*/
	}

	.border_img_parent {
		margin-top: 0;
	}

	.product_mobile {
		width: 90%;
		align-items: center;
		margin: 20px auto;
		height: auto;
		background: #f2f6fc;
	}

	.product_mobile_content {
		width: 100%;
		margin-top: 15px;
	}

	.product_mobile_content_one {
		margin-top: 5px;
	}

	.product_mobile_content_two {
		margin-top: 5px;
	}

	.product_mobile_img_div {
		display: flex;
		width: 100%;
		height: auto;
		justify-content: center;
		margin-top: 10px;
		margin-bottom: 15px;
	}

	.product_mobile_img {
		float: left;
	}

	.product_mobile_title {
		font-weight: bold;
	}

	.product_pc_one {
		width: 100%;
		margin-top: 15px;
	}

	.font_size_30 {
		font-size: 1.25em;
	}

	.product_font_style {
		font-size: 1em;
	}

	.product_pc_img {
		height: 280px;
		width: 320px;
	}

	.product_pc_img_div {
		width: 100%;
		float: left;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 15px;
	}

	.product_pc {
		display: flex;
		width: 90%;
		height: auto;
		margin: 20px auto;
		background: #f2f6fc;
		flex-direction: column;
	}

	.head-label {
		display: flex;
		margin-top: 10px;
	}

	.product_spec_parent {
		display: flex;
		width: 90%;
		align-items: center;
		justify-content: center;
		margin: 20px auto;
		height: auto;
		flex-direction: column;
	}

	.border_spec {
		float: left;
		height: auto;
		margin: 8px;
		width: 100%;
		border-radius: 6px;
		border: 1px solid #ebeef5;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.border_title {
		font-family: 'PingFang SC';
		margin-top: 5px;
		font-size: 1.125em;
		font-weight: bold;
	}

	.border_content_one {
		margin-top: 5px;
		color: #999999;
		/* font-size: 1.125em; */
	}

	.border_content_two {
		margin-top: 5px;
		font-size: 1.125em;
		margin-bottom: 8px;
		color: #0775ff;
		display: flex;
		justify-content: center;
	}

	.img_border {
		margin-top: 8px;
		width: 80px;
		height: 80px;
	}

	.border_spec_inner_one {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 8px;
		/*background-color: aqua;*/
		height: 70px;
	}

	.border_spec_content_one {
		margin-top: 5px;
		font-size: 1.125em;
		float: left;
	}

	.border_spec_inner_last {
		/*background-color: bisque;*/
		margin-top: 5px;
		font-size: 1.125em;
		float: left;
		margin-bottom: 8px;
	}

	.about_me {
		display: flex;
		margin-top: 10px;
		width: 100%;
	}
}

.border_spec_img {
	width: 75px;
	height: 55px;
	align-self: center;
}

.font_size_24 {
	font-size: 1.5em;
}
.cur {
	background: #0c76ff !important;
	color: #ffffff;
}
.cur1 {
	text-align: center;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	padding: 15px 50px;
	background: #fff;
	border-radius: 6px;
}
</style>
